import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Certifications from "../certifications/certifications";
import "./about.css";
import { faArrowDownLong } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import StaggerText from "react-stagger-text";

export default function About() {
  return (
    <div id="about" className="container mt-5 font-roobert position-relative">
      <Reveal widthClass="w-fit" revealSecondDiv={true}>
        <h1 id="about-heading" className="about-heading">
          About Me
        </h1>
      </Reveal>

      <div className="centerText position-absolute"> Why me?</div>

      <div className="row mt-5">
        <article className="col-lg-6 col-12">
          <div className="about-box h-100">
            <Reveal widthClass="w-fit">
              <h2 className="hello">
                Hello I'm <br /> Abdul Saboor
              </h2>
            </Reveal>

            <Reveal>
              <p className="hello-des">
                <StaggerText staggerDelay={0.02}>
                  I'm a full-stack developer who loves building clean,
                  efficient, and scalable solutions. I mostly work with the MERN
                  stack and Next.js to create fast, optimized web apps, and use
                  Node.js for backend automation and advanced web scraping. I'm
                  all about solving real problems with practical,
                  high-performance tools — whether it’s for startups, automation
                  scripts, or complex platforms.
                </StaggerText>
              </p>
            </Reveal>
            <br />
            <Reveal revealSecondDiv={true} widthClass="w-fit">
              <p
                style={{
                  textTransform: "capitalize",
                }}
              >
                Let's turn ideas into reality, one line of code at a time.
              </p>
            </Reveal>
            <br />
          </div>
        </article>

        <article
          className={`col-lg-4 col-md-8 col-sm-6 cert-column ms-auto position-relative`}
        >
          <motion.div
            initial={{
              opacity: 0,
              y: -20,
            }}
            transition={{
              duration: 0.3,
              delay: 0.7,
            }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <p
              className="certifications text-center"
              style={{
                fontStyle: "italic",
                fontWeight: 500,
                fontSize: 20,
              }}
            >
              Certifications
            </p>
          </motion.div>
          <div className="certifications-box">
            <Certifications />
          </div>
        </article>
        <div className="my-100">
          {" "}
          <a href="#expertise" className="text-white">
            {" "}
            <FontAwesomeIcon icon={faArrowDownLong} size="xl" />{" "}
          </a>
        </div>
      </div>
    </div>
  );
}
